import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { connect } from 'react-redux';
import { initialize } from './redux/actionCreators';
import { getIsInitialized, getBirthdayPopupState } from './redux/selectors';
const mapStateToProps = (state, ownProps)=>{
    return _object_spread({
        isInitialized: getIsInitialized(state)
    }, getBirthdayPopupState(state));
};
const mapDispatchToProps = (dispatch)=>({
        initialize: ()=>dispatch(initialize())
    });
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=BirthdayPopup.container.js.map